import { IHouseEnergyComparisonPayload } from "@edp-models/energy-comparison.model";
import { Action } from "@ngrx/store";

export enum EDefineHouseActions {
    GetServiceAnswers = "[Define House] Get Service Answers",
    SetServiceAnswers = "[Define House] Set Service Answers",
    ToggleEnergySourceSubstep = "[Define House] Toggle Answer",
    SetActiveStep = "[Define House] Set Active Step",
    SetEquipmentActiveStep = "[Define House] Set Equipment Active Step",
    SetAnswers = "[Define House] Set Answers",
    GetHouseStatusMoonShot = "[Define House Status Moonshot] Get House Status Moonshot",
    SetHouseStatusMoonShot = "[Define House Status Moonshot] Set House Status Moonshot",
    GetHouseEnergyComparison = "[Define House Energy Comparison] Get House Energy Comparison",
    SetHouseEnergyComparison = "[Define House Energy Comparison] Set House Energy Comparison",
    SetThermalInsulationActiveStep = "[Define House] Set Thermal InsulationActiveStep Active Step"
}

export class GetServiceAnswers implements Action {
    public readonly type = EDefineHouseActions.GetServiceAnswers;
}

export class GetHouseStatusMoonShot implements Action {
    public readonly type = EDefineHouseActions.GetHouseStatusMoonShot;
    constructor(public forceRequest?: boolean) {}
}

export class SetServiceAnswers implements Action {
    public readonly type = EDefineHouseActions.SetServiceAnswers;
    constructor(public payload: any) {}
}

export class SetHouseStatusMoonShot implements Action {
    public readonly type = EDefineHouseActions.SetHouseStatusMoonShot;
    constructor(public payload: any) {}
}

export class ToggleEnergySourceSubstep implements Action {
    public readonly type = EDefineHouseActions.ToggleEnergySourceSubstep;
    constructor(public payload: string) {}
}

export class SetActiveStep implements Action {
    public readonly type = EDefineHouseActions.SetActiveStep;
    constructor(public payload: number) {}
}

export class SetEquipmentActiveStep implements Action {
    public readonly type = EDefineHouseActions.SetEquipmentActiveStep;
    constructor(public payload: number) {}
}

export class SetAnswers implements Action {
    public readonly type = EDefineHouseActions.SetAnswers;
    constructor(public payload: any) {}
}

export class GetHouseEnergyComparison implements Action {
    public readonly type = EDefineHouseActions.GetHouseEnergyComparison;
    constructor(public payload: IHouseEnergyComparisonPayload) {}
}

export class SetHouseEnergyComparison implements Action {
    public readonly type = EDefineHouseActions.SetHouseEnergyComparison;
    constructor(public payload: any) {}
}

export class SetThermalInsulationActiveStep implements Action {
    public readonly type = EDefineHouseActions.SetThermalInsulationActiveStep;
    constructor(public payload: number) {}
}

export type DefineHouseActions =
    | GetServiceAnswers
    | SetServiceAnswers
    | ToggleEnergySourceSubstep
    | SetActiveStep
    | SetAnswers
    | SetEquipmentActiveStep
    | GetHouseStatusMoonShot
    | SetHouseStatusMoonShot
    | GetHouseEnergyComparison
    | SetHouseEnergyComparison
    | SetThermalInsulationActiveStep;
